"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationMySiteLetterSent = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 231 156",
    fill: "none",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: "#1657E2",
          fillOpacity: "0.14",
          d: "M133.912 25.894c-14.775-.521-28.849-5.378-42.286-10.691C78.188 9.89 64.876 4 50.456 1.185 41.178-.625 30.57-.88 23.096 4.181c-7.194 4.865-11.105 12.903-12.353 20.7-.94 5.878.095 12.433 2.669 17.93 1.788 3.818 4.964 7.025 7.161 10.68 7.638 12.72 2.244 28.405-6.042 40.825-3.875 5.826-8.389 11.384-11.385 17.585-2.996 6.201-4.383 13.308-1.762 19.634 2.6 6.272 8.793 10.981 15.501 14.293C30.513 152.558 46.071 156 61.81 156c35.096 0 69.773-.103 104.685-.103 12.875 0 25.779-.781 38.433-2.806 7.025-1.125 14.278-2.909 19.377-7.218 6.476-5.473 8.081-14.731 3.741-21.589-7.272-11.499-27.397-14.353-32.484-26.702-2.8-6.795.075-14.364 4.145-20.677 8.729-13.518 23.362-25.379 24.133-40.833.53-10.614-6.505-21.244-17.38-26.265-11.402-5.27-27.209-4.602-35.621 4.11-8.66 8.987-23.88 12.439-36.926 11.977z"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: "#1657E2",
          fillRule: "evenodd",
          d: "M79.62 105.04l3.273-29.81 147.583-27.39-150.857 57.2z",
          clipRule: "evenodd"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: "#739AEE",
          fillRule: "evenodd",
          d: "M82.728 76.96l-33.49-24.548 181.238-4.572L82.728 76.96z",
          clipRule: "evenodd"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#1657E2",
              fillRule: "evenodd",
              d: "M174.899 40.592l-37.76-22.76-31.984 30.484 4.657 43.531 69.72-7.2-4.633-44.056z",
              clipRule: "evenodd"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#fff",
              d: "M114.247 25.137l43.016-4.443 6.024 56.32-43.016 4.442-6.024-56.32z"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#fff",
              d: "M117.661 31.345l43.016-4.443 6.024 56.32-43.016 4.442-6.024-56.32z"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              stroke: "#1C895D",
              strokeWidth: "5.307",
              d: "M127.436 44.031l8.289 8.132 15.933-18.028"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                fill: "#C3D4F7",
                d: "M174.877 40.56L109.8 91.848l69.731-7.178-4.654-44.11z"
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: "#D7E2F9",
            fillRule: "evenodd",
            d: "M105.126 48.365l4.63 43.483 66.461-10.353-71.091-33.13z",
            clipRule: "evenodd"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: "#1246B5",
          fillRule: "evenodd",
          d: "M108.952 85.007L79.619 105.04l45.048-4.162-15.715-15.871z",
          clipRule: "evenodd"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: "#739AEE",
          fillRule: "evenodd",
          d: "M108.952 85.007l34.362 56.433 87.162-93.6-121.524 37.167z",
          clipRule: "evenodd"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        stroke: "#10105A",
        strokeDasharray: "3 8",
        strokeLinecap: "round",
        strokeWidth: "3",
        d: "M1.578 155.528c2.028-2.831 29.088-11.752 41.675-25.018 9.485-9.996 6.92-24.09 0-31.568-12.929-13.973-30.132.002-24.191 12.94 8.52 18.552 48.27-7.39 57.945-7.561"
      })]
    })
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationMySiteLetterSent')(IllustrationMySiteLetterSent);